import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { OrgRenameUserLoggedInConfig } from './rename-error-config';

@Injectable({
  providedIn: 'root'
})
export class FolderOrgRenameErrorModalService extends BaseModalService<OrgRenameUserLoggedInConfig> {}
